// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2Uet5","error":"Textarea_error__358C9","readonly":"Textarea_readonly__2FsDj","disabled":"Textarea_disabled__OW96j"};